//@flow
import React, { useState } from 'react'

import { useI18n } from '~/core/i18n'
import { Flex, Input, Button } from 'components/common'
import type { TimeItem } from './time-item'

type TimesListItemEditProps = {
  time: TimeItem,
  onSave: (time: TimeItem) => void
}

const TimesListItemEdit = ({ time, onSave }: TimesListItemEditProps) => {
  const [msg] = useI18n()
  const [timeValue, setTime] = useState(time.time)

  const handleSave = () => {
    onSave({ id: time.id, time: timeValue })
  }

  return (
    <Flex
      column
      style={{
        padding: '0.5rem',
        width: 300,
        maxWidth: '80vw'
      }}
    >
      <Input type="time" value={timeValue} onChange={({ target }) => setTime(target.value)} />
      <Flex
        justifyCenter
        style={{
          marginTop: '1rem'
        }}
      >
        <Button iconPosition="left" xIcon="check" onClick={() => handleSave()}>
          {msg('common.button.save')}
        </Button>
      </Flex>
    </Flex>
  )
}

export { TimesListItemEdit }
